// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon
module.exports.IoInformation = function IoInformation (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"40","d":"M196 220h64v172"}},{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"40","d":"M187 396h138"}},{"tag":"path","attr":{"d":"M256 160a32 32 0 1132-32 32 32 0 01-32 32z"}}]})(props);
};
